import * as React from 'react';
import {useEffect} from "react";
import {APP_LOGIN_PATH} from "../../types";
import {useHistory} from "react-router";
import {logout} from "../../Auth";



const Logout: React.FunctionComponent = () => {


    const doRedirect = true;
    const history = useHistory();
    useEffect(() => {
        if (doRedirect) {
            logout();
            history.push({
                pathname: APP_LOGIN_PATH
            });
        }
    },[doRedirect, history]);
    return (<>
    </>);
};

export default Logout;